import { supabase } from "../supabase";

/**
 * 도서관 정보나루 — 책 화면의 '함께 빌린 책'.
 *
 * 정보나루는 하루 500건이 넘으면 막힌다(고정 IP 가 없어 늘릴 수도 없다).
 * 그래서 아껴 쓴다.
 *   목록   op:coloan    — 정보나루 1건 (표지는 서버가 카카오에서 붙인다)
 *   소개   op:libdetail — 카드를 누를 때만 1건
 * 받은 것은 이 기기에 7일 둔다. 실패는 저장하지 않는다 — 한도에 걸린 날
 * 빈 결과를 저장했더니 일주일 동안 빈 칸이 될 뻔했다.
 */
const TTL = 7 * 24 * 60 * 60 * 1000;

function read(key) {
  try {
    const hit = JSON.parse(localStorage.getItem(key) || "null");
    if (hit && Date.now() - hit.at < TTL) return hit.v;
  } catch { /* 막힌 브라우저면 매번 받는다 */ }
  return undefined;
}
function write(key, v) {
  try { localStorage.setItem(key, JSON.stringify({ at: Date.now(), v })); } catch { /* 무시 */ }
}

export async function fetchCoLoan({ isbn, title }) {
  if (!/^97[89]\d{10}$/.test(String(isbn ?? ""))) return [];
  const key = `muroo-coloan:v3:${isbn}`;
  const hit = read(key);
  if (hit) return hit;
  const { data, error } = await supabase.functions.invoke("library-recommend", {
    body: { op: "coloan", isbn13: isbn, title },
  });
  if (error || !Array.isArray(data?.books)) throw new Error(error?.message || "coloan 실패");
  write(key, data.books);
  return data.books;
}

export async function fetchLibDetail(isbn) {
  const key = `muroo-libdetail:v1:${isbn}`;
  const hit = read(key);
  if (hit) return hit;
  const { data, error } = await supabase.functions.invoke("library-recommend", {
    body: { op: "libdetail", isbn13: isbn },
  });
  if (error || !data || data.error) throw new Error(error?.message || "libdetail 실패");
  write(key, data);
  return data;
}
